import React, { useState } from "react";
import { Container, Spinner, Modal } from "react-bootstrap";
import useBucketListView from "./useBucketListView";
import Header from "../../Common/Header";
import "./BucketListView.scss";
import Footer from "../../Common/Footer/Footer";
import { useNavigate } from "react-router-dom";
import {
  faEye,
  faL,
  faShareAlt,
  faShareNodes,
  faTrash,
  faTrashAlt,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MainLayout from "../../Common/MainLayout";

import { Select, Space } from "antd";
export default (props) => {
  const {
    loading,
    loadingDelete,
    loadingShare,
    showAddBucketModal,
    loadingCreateBucket,
    allBucketList,
    formError,
    assessmentKits,
    showDeleteBucketModal,
    deleteBucketItemInfo,
    showShareBucketModal,
    setEmailId,
    handleClose,
    onCreateClick,
    onBlurHandler,
    onSubmit,
    onViewBucketListHandler,
    onDeleteBucketListHandler,
    handleDeleteBucketModal,
    shareBucketModalHandler,
    shareBucketListByEmail,
    handleChange,
  } = useBucketListView();

  return (
    <MainLayout activeMenuItem="bucket-list" pageName={"Bucket List"}>
      <Container className="footer-gap">
        <div className="applied-job-board">
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center my-3 pb-3">
              <h2 className="text-capitalize mr-4 text-nowrap">Bucket List</h2>
            </div>
            <div className="text-right">
              {/* <button className="btn btn-light mr-3">
              <FontAwesomeIcon icon={faShareNodes} className="mr-2" />
              Share
            </button> */}
              <button className="btn btn-primary" onClick={onCreateClick}>
                Create Bucket
              </button>
            </div>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="row">
              {Array.isArray(allBucketList) && allBucketList.length ? (
                <>
                  {Array.isArray(allBucketList) &&
                    allBucketList.map((item) => (
                      <div className="col-lg-4 col-md-6 mb-4">
                        <div className="bg-white border position-relative h-100 rounded-lg shadow-2">
                          <div className="upper px-3 pt-3">
                            <div className="d-flex mb-2">
                              <div className="job-info">
                                <h3
                                  className="font-weight-medium mb-1 text-capitalize text-primary cursor-pointer"
                                  onClick={() =>
                                    onViewBucketListHandler(item?.id)
                                  }
                                >
                                  {item?.title}
                                </h3>
                              </div>

                              <button
                                className="py-1  bg-transparent  border-0 text-danger ml-auto mr-2 text-nowrap"
                                onClick={() =>
                                  handleDeleteBucketModal(
                                    true,
                                    item?.id,
                                    item?.title
                                  )
                                }
                                title="Delete Bucket"
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                            <div className="d-flex align-items-center fs-smallest mb-3 justify-content-between">
                              <div>
                                <p className="mb-0 text-capitalize font-weight-medium mr-2">
                                  Total candidates:{" "}
                                  <span className="text-grey-4 font-weight-400">
                                    {item?.total_candidates}
                                  </span>
                                </p>

                                {item.assigned_assessments_details &&
                                Array.isArray(
                                  item.assigned_assessments_details
                                ) &&
                                item.assigned_assessments_details.length > 0 ? (
                                  <div className="fs-smallest">
                                    <p className="mb-0 mr-2 d-flex align-items-center flex-wrap">
                                      <span className="font-weight-medium text-nowrap mr-2">
                                        Assessment Kits :{" "}
                                      </span>
                                      {Array.isArray(
                                        item &&
                                          item?.assigned_assessments_details
                                      ) &&
                                        item &&
                                        item?.assigned_assessments_details.map(
                                          (assessment, index) => (
                                            <span
                                              key={index}
                                              className="skill bg-grey px-2 my-1 rounded-sm mr-2 py-1 text-capitalize"
                                            >
                                              {assessment?.title}
                                            </span>
                                          )
                                        )}
                                    </p>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                          <div className="d-flex justify-content-end align-items-center flex-md-wrap flex-lg-nowrap pb-3">
                            <button
                              className="btn text-grey-4 d-flex align-items-center py-0 mr-3 text-nowrap"
                              onClick={() =>
                                shareBucketModalHandler(true, item?.id)
                              }
                              title="Share Bucket with Hiring Manager"
                            >
                              <img
                                src="/assets/images/share-icon.svg"
                                alt="share"
                                className="mr-2"
                              />{" "}
                              Share Via Email
                            </button>

                            <button
                              className="btn btn-light py-1 mr-2 text-nowrap"
                              title="View Bucket"
                              onClick={() => onViewBucketListHandler(item?.id)}
                            >
                              View
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </>
              ) : (
                <div
                  className="d-flex col-12 align-items-center
                  justify-content-center flex-column py-4"
                >
                  <img src="/assets/images/empty-state.svg" alt="empty" />
                  <h4 className="font-weight-bold mb-1 mt-2">
                    No Bucket List has been created yet !
                  </h4>
                  <p className="mb-4 fs-smallest">Start Creating Bucket List</p>
                  <button
                    onClick={onCreateClick}
                    to={"/job-board"}
                    className="px-4 border border-primary shadow
                    text-primary py-1 rounded-lg font-weight-semi"
                  >
                    Create Bucket
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </Container>
      <Modal
        size="md"
        show={showAddBucketModal}
        onHide={handleClose}
        className="border-0 common-modal apply-job-modal"
        centered
      >
        <Modal.Header className="bg-primary text-white">
          <Modal.Title className="text-uppercase">
            <h3 className="mb-0 text-white">Add bucket List</h3>
          </Modal.Title>
          <FontAwesomeIcon
            icon={faXmark}
            className="fa-2x cursor-pointer"
            onClick={handleClose}
          />
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-group mb-0 py-3">
            <p className="font-weight-medium">
              <span className="text-danger">* </span>Title
            </p>
            <div className="form-group">
              <input
                className="form-control"
                type="text"
                placeholder="Enter Title"
                name="title"
                onBlur={(e) => onBlurHandler(e)}
              />
              {formError?.title ? (
                <p className="text-danger mt-2">{formError?.title} </p>
              ) : null}
            </div>
            <div className="form-group position-relative">
              <p className="font-weight-medium">
                <span className="text-danger">* </span>Select Assessment Kit
              </p>
              <Select
                getPopupContainer={(trigger) => trigger.parentNode}
                mode="multiple"
                // popupClassName="assessment-kit-select"
                popupClassName="assessment-kit-select"
                className="w-100 py-3"
                placeholder="Select Assessment Kit"
                // defaultValue={["china"]}
                onChange={handleChange}
                optionLabelProp="label"
                // options={options}
                options={
                  Array.isArray(assessmentKits) &&
                  assessmentKits.map((assessment) => ({
                    label: assessment.title,
                    value: assessment?.id,
                  }))
                }
              />

              {formError?.interview_kit_id ? (
                <p className="text-danger mt-2">
                  {formError?.interview_kit_id}{" "}
                </p>
              ) : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center justify-content-end">
            <button className="btn btn-primary ml-4" onClick={onSubmit}>
              {loadingCreateBucket ? (
                <Spinner animation="border" variant="light" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        show={showDeleteBucketModal}
        onHide={() => handleDeleteBucketModal(false)}
        className="border-0"
        centered
      >
        <Modal.Header className="bg-primary text-white">
          <Modal.Title className="text-uppercase">
            <h3 className="mb-0 text-white">Add bucket List</h3>
          </Modal.Title>
          <FontAwesomeIcon
            icon={faXmark}
            className="fa-2x cursor-pointer"
            onClick={() => handleDeleteBucketModal(false)}
          />
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-group mb-0 py-3">
            <p className="font-weight-medium">
              Do You Want to Delete{" "}
              <strong className="text-primary">
                {deleteBucketItemInfo?.title}
              </strong>{" "}
              ?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center justify-content-end">
            <button
              className="btn btn-danger ml-4"
              onClick={() =>
                onDeleteBucketListHandler(deleteBucketItemInfo?.id)
              }
            >
              {loadingDelete ? (
                <Spinner animation="border" variant="light" />
              ) : (
                "Delete"
              )}
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        size="md"
        show={showShareBucketModal}
        onHide={() => shareBucketModalHandler(false)}
        className="border-0 common-modal apply-job-modal"
        centered
      >
        <Modal.Header className="bg-primary text-white">
          <Modal.Title className="text-uppercase">
            <h3 className="mb-0 text-white">Share Bucket</h3>
          </Modal.Title>
          <FontAwesomeIcon
            icon={faXmark}
            className="fa-2x cursor-pointer"
            onClick={() => shareBucketModalHandler(false)}
          />
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="form-group mb-0 py-3">
            <p className="font-weight-medium">
              <span className="text-danger">* </span>Enter Email Id
            </p>
            <div className="form-group">
              <input
                className="form-control"
                type="text"
                placeholder="Enter Hiring Manager's Email Id"
                name="title"
                onBlur={(e) => setEmailId(e.target.value)}
              />
              {formError?.emailId ? (
                <p className="text-danger mt-2">{formError?.emailId} </p>
              ) : null}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center justify-content-end">
            <button
              className="btn btn-primary ml-4"
              onClick={() => shareBucketListByEmail()}
            >
              {loadingShare ? (
                <Spinner animation="border" variant="light" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </MainLayout>
  );
};
